module.exports = __webpack_public_path__ + "static/media/RoundedRect_Secondary.281e5461.png";